var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015&cacheDirectory=true&sourceMap=true!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./sky-svg.vue"),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/sky-svg/sky-svg.vue
// module id = 259
// module chunks = 1